/**
 * Subject id for GET /policy/me and policy guards.
 * Prefer Hub userId (local_hub_user_attributes key) before Mongo/app id.
 */
export function resolvePolicySubjectId(user) {
  if (!user || typeof user !== 'object') return null;
  const candidates = [
    user.userId,
    user.id,
    user._id,
  ];
  for (const raw of candidates) {
    if (raw === undefined || raw === null || raw === '') continue;
    const s = String(raw).trim();
    if (s) return s;
  }
  return null;
}
